export default function getUtcTimestamp(time) {
  return time.getTime() - time.getTimezoneOffset() * 60 * 1000;
}
